import { LeakedPasswordCheckSkippedReason } from 'persistable-types';

import isPin from './isPin';

export default function getLeakedPasswordCheckSkipReason(password: string) {
  if (password === '') {
    return LeakedPasswordCheckSkippedReason.empty;
  }

  // We don't leak check numerical passwords. These are most likely PINs, which are in general
  // protected by a limited number of tries on entry.
  if (isPin(password)) {
    return LeakedPasswordCheckSkippedReason.pin;
  }

  return undefined;
}
